import { SHOW_IN_MA_VACH_TAI_SAN } from "actions/InMaVachTaiSan/actionTypes";

const initialState = {
  showModalInMaVach: false,
};
const showInMaVachTaiSan = (state, action) => ({
  ...state,
  showModalInMaVach: !state.showModalInMaVach,
});

const inMaVachTaiSanReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_IN_MA_VACH_TAI_SAN:
      return showInMaVachTaiSan(state, action);
    default:
      return state;
  }
};

export default inMaVachTaiSanReducer;
